import { WishlistState } from 'mk2/apps/strollers/containers/WishList/WishList.reducers';
import { LoadingState } from 'mk2/reducers/loadingState';

export const initialStrollersWishListState: WishlistState = {
    currentWishlist: [],
    wishlistItemsIds: [],
    loadingState: LoadingState.INIT,
    errorMessage: null,
    hasMore: false,
};
